import React from 'react';
import { View } from 'react-native';
import PropTypes from 'prop-types';
import R from '../../core-res/R';
import DRNTouchableWrapper from '../Button/TouchableButtonWrapper';
import DRNText from '../../standard/Text/DRNText';
import { getSizeVariantStyle, getLabelVariant } from './variant/size';
import { withTheme } from '../../theme';
import { withSmartKey } from '../../smartkey';
class RadioButton extends React.Component {
    constructor() {
        super(...arguments);
        this.renderRadioButton = () => {
            const { color, value, disabled, size, theme } = this.props;
            let radioColor = color ? color : theme.tintPrimary;
            if (disabled) {
                radioColor = theme.lightSecondary;
            }
            const style = value
                ? Object.assign({}, styles.selectedRadioButton, { backgroundColor: radioColor, borderColor: radioColor }) : { borderColor: theme.lightSecondary, borderWidth: R.border.width.thick };
            const sizeVariantStyles = getSizeVariantStyle(size);
            return (<View style={[styles.centered, sizeVariantStyles.frame]}>
        <View style={[styles.centered, sizeVariantStyles.radio, style]}>
          <View style={[
                styles.bullet,
                sizeVariantStyles.bullet,
                value && Object.assign({}, styles.selectedBullet, { backgroundColor: radioColor }),
            ]}/>
        </View>
      </View>);
        };
        this.handleOnChange = () => {
            const { value, onChange } = this.props;
            onChange(!value);
        };
    }
    render() {
        const { label, description, disabled, size, onChange: handleOnChange, accessibilityLabel, testID } = this.props;
        return (<DRNTouchableWrapper accessible={false} disabled={disabled} onPress={handleOnChange}>
        <View style={styles.container}>
          {this.renderRadioButton()}
          {label ? (<View style={styles.labelContainer}>
              <DRNText variant={getLabelVariant(size)} ink={disabled ? 'muted' : 'primary'} accessibilityLabel={accessibilityLabel} testID={testID}>
                {label}
              </DRNText>
              {!!description && (<DRNText style={styles.descriptionText} ink={disabled ? 'muted' : 'secondary'}>
                  {description}
                </DRNText>)}
            </View>) : null}
        </View>
      </DRNTouchableWrapper>);
    }
}
RadioButton.smartKeyName = ['label', 'description'];
RadioButton.propTypes = {
    label: PropTypes.string,
    description: PropTypes.string,
    value: PropTypes.bool,
    color: PropTypes.string,
    disabled: PropTypes.bool,
    onChange: PropTypes.func,
    size: PropTypes.oneOf(['small', 'medium']),
    theme: PropTypes.object,
    accessibilityLabel: PropTypes.string,
    testID: PropTypes.string,
};
RadioButton.defaultProps = {
    value: false,
    disabled: false,
    size: 'medium',
    onChange: () => 0,
};
export default withSmartKey(withTheme(RadioButton));
const styles = {
    container: {
        flexDirection: 'row',
        alignItems: 'flex-start',
        padding: R.spacing.m,
    },
    labelContainer: {
        flex: 1,
        flexDirection: 'column',
        marginLeft: R.spacing.s,
    },
    centered: {
        justifyContent: 'center',
        alignItems: 'center',
    },
    bullet: {
        borderColor: R.color.uiLightNeutral,
        borderWidth: R.border.width.bold,
    },
    selectedBullet: {
        borderColor: R.color.uiLightPrimary,
    },
    selectedRadioButton: {
        borderWidth: R.border.width.thick,
    },
    descriptionText: Object.assign({}, R.typography.uiTiny),
};
